import { useEffect, useState } from "react";
import { TypewriterText } from "./TypewriterText";
import { trans } from "@mongez/localization";

const motivationalQuotes = [
  // Self-Improvement & Personal Development
  "تحسين الذات يبدأ بالوعي الذاتي، ثم التخطيط الذكي، وأخيراً التنفيذ المستمر حتى تصبح النسخة الأفضل من نفسك",
  "كل يوم فرصة جديدة لتصبح شخصاً أفضل، استثمر في تطوير شخصيتك ومهاراتك وستحصد النتائج المذهلة",
  "التحسين المستمر للذات ليس خياراً، بل ضرورة في عصر التطور السريع، كن دائماً في حالة تعلم وتطوير",
  "تمكين نفسك يبدأ بالاعتقاد في قدراتك، ثم الاستثمار في تطويرها، وأخيراً استخدامها لتحقيق أهدافك العظيمة",
  "كل خطوة تتخذها نحو تحسين ذاتك تضيف إلى رصيدك الشخصي وتجعلك أكثر قدرة على مواجهة تحديات الحياة",
  "التحسين الذاتي هو الاستثمار الأكثر ربحية، فهو يضمن لك عائداً مضموناً في كل مجال من مجالات حياتك",
  "كن سيد قراراتك، واستثمر في قدراتك، وستجد نفسك قادراً على تحقيق أحلامك وتحويلها إلى واقع ملموس",
  "التحسين المستمر للذات يجعل منك شخصاً لا يقبل إلا بالأفضل، ويجعل من التميز عادة يومية في حياتك",
  "كل تجربة تمر بها في رحلة تحسين الذات تضيف إلى خبرتك وتجعلك أكثر حكمة ونضجاً وقدرة على النجاح",
  "تمكين نفسك يعني أن تكون قادراً على خلق الفرص بدلاً من انتظارها، وهذا يتطلب استثماراً مستمراً في الذات",

  // Time Management
  "إدارة الوقت بفعالية هي المفتاح للنجاح، كل دقيقة تستثمرها بحكمة تضاعف من إنتاجيتك وتحقق أهدافك",
  "الوقت أثمن من الذهب، استثمره في الأنشطة التي تضيف قيمة لحياتك وتقربك من أهدافك المهمة",
  "إدارة الوقت الجيدة تبدأ بالتخطيط الذكي، ثم تحديد الأولويات، وأخيراً التنفيذ المنظم والمتابعة المستمرة",
  "كل ساعة تديرها بحكمة تساوي ألف ساعة من العمل العشوائي، تعلم كيف تستثمر وقتك بفعالية",
  "الوقت كالسيف إن لم تقطعه قطعك، استثمر كل لحظة في التعلم والتطوير وستحصد النتائج المذهلة",
  "إدارة الوقت ليست مجرد تنظيم، بل هي فلسفة حياة تجعل من كل دقيقة فرصة للتحسين والتطوير",
  "الوقت الذي تقضيه في التخطيط يوفر عليك وقتاً مضاعفاً في التنفيذ، استثمر في التخطيط الجيد",
  "كل دقيقة تضيعها هي فرصة ضائعة للنجاح، تعلم كيف تستثمر وقتك بحكمة وستحقق نتائج مذهلة",
  "إدارة الوقت الفعالة تجعل منك شخصاً منتجاً ومؤثراً، وتضمن لك تحقيق أهدافك في الوقت المحدد",
  "الوقت هو المورد الوحيد الذي لا يمكن استرجاعه، استثمره في ما يضيف قيمة حقيقية لحياتك",

  // Energy Management
  "إدارة الطاقة أهم من إدارة الوقت، ركز طاقتك على الأنشطة التي تضيف قيمة حقيقية لحياتك",
  "طاقتك محدودة، استثمرها بحكمة في المشاريع والأشخاص الذين يضيفون قيمة لحياتك ويطورونك",
  "إدارة الطاقة تبدأ بالوعي بطاقتك، ثم توجيهها نحو الأهداف المهمة، وأخيراً تجديدها باستمرار",
  "كل ساعة من الطاقة المركزة تساوي عشر ساعات من العمل المشتت، تعلم كيف تركز طاقتك بفعالية",
  "طاقتك العقلية والجسدية هما رأس مالك الحقيقي، استثمرهما بحكمة وستحقق نتائج مذهلة",
  "إدارة الطاقة الجيدة تجعل منك شخصاً منتجاً ومبدعاً، وتضمن لك الاستمرار في النجاح طويل المدى",
  "طاقتك الإيجابية معدية، استثمرها في تطوير نفسك والآخرين، وستحصد نتائج مذهلة",
  "كل يوم جديد هو فرصة لتجديد طاقتك وتوجيهها نحو تحقيق أهدافك وأحلامك العظيمة",
  "إدارة الطاقة تبدأ بالصحة الجيدة، ثم التغذية السليمة، وأخيراً الراحة الكافية للاستمرار",
  "طاقتك العاطفية والعقلية هما المحرك الأساسي لنجاحك، استثمر في تطويرهما واستدامتهما",

  // Money & Financial Investment
  "إدارة أموالك بحكمة تبدأ بالوعي المالي، ثم التخطيط الذكي، وأخيراً الاستثمار المستمر في تعليمك ومهاراتك",
  "كل ريال تستثمره في تعليمك اليوم سيعود عليك بعشرة أضعاف في المستقبل، فالتعليم استثمار لا يفشل أبداً",
  "الاستثمار في تعليمك هو أفضل استثمار مالي يمكن أن تقوم به، فهو يضمن لك عائداً مضموناً طوال حياتك",
  "إدارة المال الجيدة تبدأ بالادخار، ثم الاستثمار، وأخيراً التطوير المستمر لقدراتك لكسب المزيد",
  "كل شهادة مهنية تحصل عليها هي استثمار في مستقبلك المالي وضمانة لاستقرارك الاقتصادي",
  "الاستثمار في المهارات الرقمية والتقنيات الحديثة يضمن لك مكانة في سوق العمل المستقبلي وراتباً أعلى",
  "إدارة المخاطر المالية تبدأ بالاستثمار في تعليمك، فهو أقل المخاطر وأعلى العوائد على المدى الطويل",
  "كل مهارة جديدة تتعلمها تزيد من قيمتك في سوق العمل وتضمن لك دخلاً أعلى ومستقبلاً مالياً أفضل",
  "الاستثمار في الشبكات المهنية والعلاقات الاجتماعية يفتح لك أبواب الفرص المالية التي لا يمكن أن تفتحها المهارات وحدها",
  "إدارة أموالك بحكمة تعني الاستثمار في تطوير قدراتك، فقدراتك هي المصدر الأساسي لدخلك المستقبلي",

  // Life Investment
  "استثمارك في الحياة يبدأ بالاستثمار في نفسك، ثم في علاقاتك، وأخيراً في مساهمتك في تطوير المجتمع",
  "كل تجربة تعليمية تشارك فيها هي استثمار في رصيدك الإنساني وتوسع آفاقك وتثري تجربتك في الحياة",
  "الاستثمار في الصحة البدنية والعقلية يضمن لك القدرة على الاستمرار في التعلم والعمل بكفاءة عالية",
  "استثمارك في العلاقات الإيجابية يفتح لك أبواب الفرص ويجعل من رحلة الحياة رحلة ممتعة ومثمرة",
  "كل مشروع تطوعي تشارك فيه يطور مهاراتك القيادية والاجتماعية ويضيف إلى رصيدك الإنساني",
  "الاستثمار في السفر والتعرف على الثقافات المختلفة يوسع آفاقك ويجعلك مواطناً عالمياً قيماً",
  "استثمارك في الهوايات والاهتمامات الشخصية يطور إبداعك ويجعل من الحياة تجربة غنية ومتنوعة",
  "الاستثمار في القراءة والثقافة يوسع آفاقك ويجعلك أكثر فهماً للعالم من حولك وأكثر قدرة على التأثير فيه",
  "كل تجربة قيادية تمر بها تطور مهاراتك الإدارية وتجعلك أكثر قدرة على إدارة الحياة بكفاءة عالية",
  "الاستثمار في تطوير المجتمع والمساهمة في الخير العام يضيف معنى لحياتك ويجعل منك شخصاً مؤثراً ومحترماً",
  "استثمارك في التوازن بين العمل والحياة يضمن لك حياة سعيدة ومستقرة ومليئة بالإنجازات والتحقيق الذاتي",
  "الاستثمار في المهارات الإبداعية والابتكارية يجعلك قادراً على خلق حلول فريدة للمشكلات المعقدة في الحياة",
  "كل شهادة دولية تحصل عليها تفتح لك أبواب الفرص العالمية وتجعل منك مواطناً عالمياً قيماً ومؤثراً",
  "الاستثمار في المهارات الرقمية والتكنولوجيا يضمن لك البقاء في طليعة التطور ومواكبة التغييرات المستقبلية",
  "استثمارك في تطوير مهارات التواصل والعرض والتقديم يجعلك قادراً على التأثير في الآخرين وإقناعهم بأفكارك",
  "الاستثمار في المهارات التحليلية والبحثية يجعلك قادراً على اتخاذ قرارات مدروسة ومبنية على الأدلة في الحياة",
  "كل تجربة تعليمية دولية تشارك فيها تثري خبرتك الثقافية وتجعل منك مواطناً عالمياً قيماً ومؤثراً",
  "الاستثمار في المهارات الاستراتيجية والتخطيط طويل المدى يضمن لك مستقبلاً مستقراً ومزدهراً في كل مجالات الحياة",
  "استثمارك في تطوير الذكاء العاطفي يجعلك قادراً على إدارة العلاقات بفعالية ويضمن لك نجاحاً في الحياة الشخصية والمهنية",
  "الاستثمار في المهارات القيادية التحويلية يضمن لك مكانة في قيادة التغيير الاجتماعي والاقتصادي وتطوير المجتمع نحو الأفضل",
  "استثمارك في عقلية النمو والتعلم المستمر يضمن لك النجاح طويل المدى والتميز الدائم في كل مجالات الحياة",
  "الاستثمار في المهارات الرقمية المستقبلية يضمن لك مكانة في الثورة الصناعية الرابعة والاقتصاد المعرفي الجديد",
  "استثمارك في تطوير الرؤية المستقبلية والتخطيط الاستراتيجي يجعلك قادراً على تحقيق أحلامك وتحويلها إلى واقع ملموس",
  "الاستثمار في المهارات الابتكارية والإبداعية يجعلك قادراً على خلق حلول فريدة للتحديات المستقبلية والمساهمة في تطوير المجتمع",
  "استثمارك في تطوير المرونة والقدرة على التكيف يضمن لك النجاح في عصر التغيير السريع والتميز في كل مجالات الحياة",
  "الاستثمار في المهارات القيادية الاستراتيجية يضمن لك مكانة في قيادة المؤسسات الكبرى والمشاريع العظيمة وتطوير المجتمع",
  "استثمارك في تطوير المسؤولية الاجتماعية والمساهمة في الخير العام يضيف معنى لحياتك ويجعل منك شخصاً مؤثراً ومحترماً في المجتمع",
  "الاستثمار في تطوير عقلية التطوير المستمر والتعلم مدى الحياة يضمن لك النجاح المستدام والتميز الدائم في كل مجالات الحياة الشخصية والمهنية والاجتماعية",

  // Additional quotes for older students
  "المعرفة هي القوة الحقيقية في عصر المعلومات، والتعليم هو الاستثمار الأكثر ربحية في مستقبلك المهني والشخصي",
  "التميز ليس مجرد هدف تصل إليه، بل هو عادة يومية تتبناها في كل ما تفعله، من الدراسة إلى العمل إلى الحياة الشخصية",
  "كل تحدٍ تواجهه في رحلة التعلم يجعلك أقوى وأكثر حكمة، ويطور قدرتك على مواجهة تحديات المستقبل بثقة",
  "النجاح في الجامعة ليس مجرد شهادة، بل هو مفتاح يفتح لك أبواب الحياة المهنية ويفتح أمامك عالماً من الفرص المذهلة",
  "الدراسة الجادة اليوم ليست مجرد واجب، بل هي استثمار في مستقبلك، وكل ساعة تقضيها في التعلم ستؤتي ثمارها غداً",
  "لا تنتظر الفرصة لتطرق بابك، اصنعها بنفسك من خلال التعلم المستمر والتطوير الذاتي والاستعداد الجيد للمستقبل",
  "الطموح الأكاديمي هو المحرك الذي يدفعك نحو التميز المهني، ويجعل منك شخصاً لا يقبل إلا بالأفضل في كل مجال",
  "كل مادة تدرسها وكل كتاب تقرؤه يضيف إلى رصيدك المعرفي ويوسع آفاقك ويفتح أمامك عالماً جديداً من الإمكانيات",
  "النجاح الأكاديمي ليس نهاية المطاف، بل هو بداية الطريق نحو النجاح المهني والحياة المليئة بالإنجازات والتحقيق الذاتي",
  "الوقت الذي تستثمره في الدراسة والبحث والتعلم هو استثمار في مستقبلك، وستحصد ثماره طوال حياتك المهنية والشخصية",
  "التميز في الدراسة يفتح أمامك أبواب الفرص الوظيفية المذهلة، ويجعل منك مرشحاً قوياً في سوق العمل التنافسي",
  "كل مشروع أكاديمي تعمل عليه يطور مهاراتك العملية ويوسع خبرتك ويجعلك أكثر جاهزية لمواجهة تحديات الحياة المهنية",
  "النجاح في الحياة يحتاج إلى تخطيط ذكي وتنفيذ دقيق ومتابعة مستمرة، وهذه المهارات تتعلمها من خلال الدراسة المنظمة",
  "الدراسة المنظمة والمخططة تختصر عليك الطريق نحو النجاح، وتجعل من رحلة التعلم رحلة ممتعة ومثمرة",
  "كل بحث أكاديمي تقوم به يوسع آفاقك المعرفية ويطور مهاراتك البحثية ويجعلك أكثر قدرة على حل المشكلات المعقدة",
  "الطموح العلمي يدفعك نحو الابتكار والإبداع، ويجعل منك شخصاً يساهم في تطوير المجتمع وتقدم البشرية",
  "النجاح الأكاديمي ليس هدفاً بحد ذاته، بل هو بداية جديدة لرحلة من التعلم المستمر والتطوير الذاتي والإنجازات العظيمة",
  "كل تجربة تعليمية تمر بها تضيف إلى شخصيتك المهنية وتطور مهاراتك الاجتماعية وتجعلك أكثر نضجاً وحكمة",
  "التميز في الدراسة لا يجعلك متميزاً في العمل فحسب، بل يجعلك قائداً في مجالك ومرجعاً للآخرين",
  "الوقت المستثمر في التعلم والبحث والتطوير لا يضيع أبداً، بل هو استثمار يضمن لك مستقبلاً مشرقاً ومليئاً بالإنجازات",
  "كل مهارة تكتسبها من خلال الدراسة والتدريب تفتح لك باباً جديداً في الحياة وتوسع خياراتك المهنية والشخصية",
  "النجاح الأكاديمي يبني الثقة بالنفس ويطور قدرتك على مواجهة التحديات ويجعلك أكثر قدرة على تحقيق أحلامك",
  "الدراسة الجادة والمنظمة تطور التفكير النقدي والتحليلي، وهذه المهارات ضرورية للنجاح في أي مجال من مجالات الحياة",
  "كل مشكلة أكاديمية تحلها بنجاح تطور مهاراتك التحليلية وتجعلك أكثر قدرة على مواجهة تحديات الحياة المعقدة",
  "الطموح العلمي يدفعك نحو الاكتشاف والابتكار، ويجعل منك شخصاً يساهم في تطوير المعرفة البشرية وتقدم المجتمع",
  "النجاح في الدراسة يفتح أمامك أبواب الفرص الدولية، ويجعل منك مواطناً عالمياً قادراً على العمل في أي مكان في العالم",
  "كل بحث علمي تساهم فيه يضيف إلى رصيدك الأكاديمي ويطور مهاراتك البحثية ويجعل منك خبيراً في مجالك",
  "التميز الأكاديمي يجعلك مرشحاً قوياً في سوق العمل التنافسي، ويضمن لك مكانة مرموقة في مجالك المهني",
  "الوقت الذي تقضيه في الدراسة والبحث والتعلم هو استثمار في ذاتك وفي مستقبلك، وستحصد ثماره طوال حياتك",
  "كل مشروع أكاديمي تكملة بنجاح يطور مهاراتك القيادية ويجعلك أكثر قدرة على إدارة الفرق والمشاريع المعقدة",
  "النجاح الأكاديمي يبني أساساً قوياً ومتيناً لمستقبلك، ويضمن لك حياة مهنية ناجحة ومليئة بالإنجازات والتحقيق الذاتي",
  "الدراسة المنهجية والمنظمة تطور مهارات حل المشكلات، وهذه المهارة ضرورية للنجاح في الحياة المهنية والشخصية",
  "كل تجربة تعليمية تشارك فيها تثري خبرتك وتوسع آفاقك وتجعلك أكثر فهماً للعالم من حولك",
  "الطموح العلمي يدفعك نحو التميز في كل مجال من مجالات الحياة، ويجعل منك شخصاً يسعى دائماً للأفضل",
  "النجاح الأكاديمي ليس هدفاً بحد ذاته، بل هو وسيلة نحو النجاح الشامل في الحياة المهنية والشخصية والاجتماعية",
];

interface EncouragingQuoteProps {
  rtl?: boolean;
}

export function EncouragingQuote({ rtl = false }: EncouragingQuoteProps) {
  const [selectedQuote, setSelectedQuote] = useState("");

  const pickRandomQuote = () => {
    const randomIndex = Math.floor(Math.random() * motivationalQuotes.length);
    setSelectedQuote(motivationalQuotes[randomIndex]);
  };

  useEffect(() => {
    // Pick a random quote when component mounts
    pickRandomQuote();
  }, []);

  const handleTypingComplete = () => {
    setTimeout(() => {
      pickRandomQuote();
    }, 5_000);
  };

  return (
    <div
      className={`absolute inset-0 flex items-center justify-center ${rtl ? "pr-20" : "pl-20"} max-w-2xl text-white`}
    >
      <div className="text-center">
        <h2 className="mb-6 text-[2.5rem] font-bold leading-tight">
          {trans("auth.welcome")}
        </h2>
        <div className="text-xl text-gray-100">
          <TypewriterText
            text={selectedQuote}
            key={selectedQuote}
            speed={30}
            onComplete={handleTypingComplete}
            className="leading-relaxed"
          />
        </div>
      </div>
    </div>
  );
}
